@if (oportunidadRealEstate) {
  <a id="ficha-home-realestate" href="{{domainUrl + getBaseUrl() + oportunidadRealEstate.slug}}" [target]="target"
    id="realestate-proyecto-{{oportunidadRealEstate.slug}}"
    class="row gx-0 bg-primary-50 primary-900 border-1 border-radius-2 border-primary-300 pointer shadow-4 oportunidad-realestate"
    title="Ir al proyecto">
    <div class="col-12">
      <div class="estadoRonda">
        <app-tag-estado-ronda [tipoEstadoRonda]="oportunidadRealEstate.tipoEstadoRonda"></app-tag-estado-ronda>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      @if (oportunidadRealEstate && oportunidadRealEstate?.galeria[0]) {
        <div class="card-background"
          [ngStyle]="{'background-image': 'url(' + oportunidadRealEstate.galeria[0].publicUrl + ')'}">
        </div>
      }
    </div>
    <div class="col-12 col-lg-8 p-2 p-lg-3">
      <div class="d-flex align-items-center mt-1 mb-3">
        <app-dias-restantes [plataforma]="'realestate'" [diasRestantes]="oportunidadRealEstate.diasRestantes"
        [isFinanciado]="isDiasRestantesFinanciado" [ngClass]="{'me-2': isDiasRestantesFinanciado || oportunidadRealEstate.diasRestantes >= 0}"></app-dias-restantes>
        <app-ubicacion-proyecto [ubicacion]="oportunidadRealEstate.ciudad"></app-ubicacion-proyecto>
      </div>
      <h2 class="h2-semibold primary-900 mb-2">{{oportunidadRealEstate.nombre}}</h2>
      <p class="p2-medium neutral-800 mb-3">{{oportunidadRealEstate.descripcionMini}}</p>
      <div class="d-sm-flex align-items-end justify-content-between">
        <p class="p2-cifras mb-1">{{oportunidadRealEstate.capitalSolicitado}}</p>
        <p class="p2-regular neutral-900 mb-1">{{oportunidadRealEstate.capitalRecaudado ?
          oportunidadRealEstate.capitalRecaudado : "0,00 €"}} conseguidos |
        {{oportunidadRealEstate.porcientoFinanciado}}%</p>
      </div>
      <div class="mt-1 mb-3">
        <app-progress-bar [porcientoCompletado]="oportunidadRealEstate.porcientoFinanciado"></app-progress-bar>
      </div>
      <div class="d-none d-lg-block">
        <div class="row">
          <div class="col-3">
            <p class="neutral-800 p2-medium mb-1">Tipo interés</p>
            <p class="p2-bold mb-0">{{oportunidadRealEstate.tipoInteres}}</p>
          </div>
          <div class="col-4">
            <p class="neutral-800 p2-medium mb-1">Plazo del préstamo</p>
            <p class="p2-bold mb-0">{{oportunidadRealEstate.plazoMeses}} meses</p>
          </div>
          <div class="col-3">
            <p class="neutral-800 p2-medium mb-1">Pago intereses</p>
            <p class="p2-bold mb-0">{{oportunidadRealEstate.tipoProyectoNombre}}
            </p>
          </div>
        </div>
      </div>
      <div class="d-block d-lg-none">
        <div class="row mb-2">
          <div class="col-6">
            <p class="neutral-800 p2-medium">Tipo interés</p>
          </div>
          <div class="col-6 text-end">
            <p class="p2-bold">{{oportunidadRealEstate.tipoInteres}}
            </p>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <p class="neutral-800 p2-medium">Plazo del préstamo</p>
          </div>
          <div class="col-6 text-end">
            <p class="p2-bold">{{oportunidadRealEstate.plazoMeses}} meses</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <p class="neutral-800 p2-medium">Pago de intereses</p>
          </div>
          <div class="col-6 text-end">
            <p class="p2-bold">
            {{oportunidadRealEstate.tipoProyectoNombre}}</p>
          </div>
        </div>
      </div>
    </div>
  </a>
}